// WARNING: Auto generated using terraform/write_aws_exports.sh

const amplifyConfig = {
    cognito: {
        REGION: "eu-central-1",
        USER_POOL_ID: "eu-central-1_LbGHjdb1D",
        IDENTITY_POOL_ID: "eu-central-1:d3711d8d-0022-45dd-bd7e-880f2c3596eb",
        APP_CLIENT_ID: "1o7ccn6jciffhnb9mmdkllhttc",
    },
    s3_upload: {
        BUCKET: "956575920639-gtms4-upload",
        REGION: "eu-central-1",
    },
    s3_static: {
        BUCKET: "956575920639-gtms4-static",
        REGION: "eu-central-1",
    },
    api: {
        ENDPOINT: "https://n4qdvum9s4.execute-api.eu-central-1.amazonaws.com/v1",
        REGION: "eu-central-1",
    },
    map: {
        NAME: "gtms4-map",
        REGION: "eu-central-1",
    }
};
export default amplifyConfig;
